import React from 'react';
import {
    PageWrapper,
    LogoImg,
    Card,
    IconWrapper,
    MainContent,
    Title,
    BodyText,
    ForecastText,
    Bold,
} from './styles';
import WrenchDuo from 'assets/icons/WrenchDuo';

const MaintenancePage: React.FC = () => {
    const endsAt = process.env.REACT_APP_MAINTENANCE_WINDOW_MESSAGE;

    document.title = 'Em manutenção – SAMM';

    return (
        <PageWrapper>
            <LogoImg src={require('assets/images/sam branco.png')} alt="SAMM" />
            <MainContent aria-label="Página em manutenção">
                <Card>
                    <IconWrapper>
                        <WrenchDuo size={80} aria-hidden />
                    </IconWrapper>
                    <Title>Em manutenção</Title>
                    <BodyText>
                        Estamos realizando uma manutenção para melhorar sua
                        experiência na plataforma.
                    </BodyText>
                    <BodyText>
                        Lamentamos qualquer inconveniência. Estamos quase lá.
                    </BodyText>
                    <ForecastText>
                        Previsão: <Bold>{endsAt??'em breve'}</Bold>
                    </ForecastText>
                </Card>
            </MainContent>
        </PageWrapper>
    );
};

export default MaintenancePage;
